var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames,attrs:{"id":_vm.ids,"data-parallax-video":"true","data-jarallax-video":"m4v:../../../../assets/video/01.m4v,webm:../../../../assets/video/01.webm,ogv:../../../../assets/video/01.ogv"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }